<div class="dropdown">
  <ng-content></ng-content>
</div>
